import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Modules',
  basePath: '/modules',
  columns: [
    { key: 'module', label: 'Module', sortable: true },
    { key: 'mandatory', label: 'Mandatory', sortable: true,
      render: (v) => (/** @type {unknown} */ (v) === 1 || v === '1' || v === true) ? 'Yes' : 'No' },
  ],
  fields: [
    { key: 'module', label: 'Module', type: 'text', required: true },
    { key: 'mandatory', label: 'Mandatory', type: 'yesno', defaultValue: 0 },
  ],
});
